import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import TierSidebarCard from '../../../DeviationViews/TierSidebarCard';
import SidebarBlock from '../../_partials/SidebarBlock';
import Placeholder from '../../_partials/Placeholder';
import lodashTimes from 'lodash/times';
import s from './TiersBlock.scss';
export var TiersBlock = function (_a) {
    var streamKey = _a.streamKey, deviation = _a.deviation, tiers = _a.tiers, isLoading = _a.isLoading;
    var tier = useSubscriptionTier(deviation).tier;
    var author = tier === null || tier === void 0 ? void 0 : tier.author;
    var seeAll = useMemo(function () { return ({
        href: (author === null || author === void 0 ? void 0 : author.username) && Url.userLink(author.username, 'subscriptions'),
        biData: {
            creatorid: author === null || author === void 0 ? void 0 : author.useridUuid,
        },
    }); }, [author === null || author === void 0 ? void 0 : author.username, author === null || author === void 0 ? void 0 : author.useridUuid]);
    var isSelectedTierBlock = streamKey === 'selectedTier' && !!tier;
    var hasTiers = tiers && tiers.length;
    var isValidBlock = isSelectedTierBlock || hasTiers;
    var member_subscriptions = useFlag('member_subscriptions');
    if (!isValidBlock || !member_subscriptions) {
        return null;
    }
    var isShowingPlaceHolders = !isSelectedTierBlock && isLoading;
    var isShowingTierList = !isSelectedTierBlock && !isLoading && hasTiers;
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: streamKey } },
        React.createElement(SidebarBlock, { streamKey: streamKey, headerClassname: s['header'], titleClassname: s['title'], linkClassname: s['link'], isLoading: isLoading, seeAll: seeAll },
            isSelectedTierBlock && (React.createElement(TierSidebarCard, { className: classnames(s['selected-tier'], s['tier']), deviation: tier })),
            isShowingPlaceHolders &&
                lodashTimes(3, function (index) { return (React.createElement(Placeholder, { key: index, className: s['tier'] })); }),
            isShowingTierList &&
                tiers
                    // backend can do strange stuff...
                    .filter(function (otherTier) { return !!otherTier; })
                    .slice(0, 3)
                    .map(function (otherTier) { return (React.createElement(TierSidebarCard, { key: otherTier.deviationId, className: s['tier'], deviation: otherTier })); }))));
};
TiersBlock.displayName = 'TiersBlock';
export default TiersBlock;
//# sourceMappingURL=TiersBlock.js.map